// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "public" + "." + "bfe8a4f4" + ".js";
};